import { SVGProps } from 'react';

const ListStart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M16 12H3m13 6H3m7-12H3m18 12V8a2 2 0 0 0-2-2h-5m2-2-2 2 2 2"
    />
  </svg>
);
export default ListStart;
